import React from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import { useAuth } from '../../contexts/AuthContext'

const Login = () => {
  const { login } = useAuth()
  return (
    <>
      <Grid item sx={{ pt: '15%' }}>
        <Typography sx={{ textAlign: 'center' }} variant='h1'>
          Login with your <br /> HDM Office 365 Account
        </Typography>
      </Grid>
      <Grid item>
        <Button
          sx={{ fontSize: '16px', mt: 2 }}
          variant='outlined'
          onClick={login}
        >
          Login
        </Button>
      </Grid>
    </>
  )
}

export default Login
